import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={48}
        height={48}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx={24} cy={24} r={24} fill="#FA6FE5" />
        <path
            d="M12 31.9494V30.616H24.744V31.9494H12ZM12 25.564V24.2307H17.9493V25.564H12ZM12 19.18V17.8467H17.9493V19.18H12ZM35.056 32L29.872 26.8934C29.3893 27.2534 28.8658 27.532 28.3013 27.7294C27.736 27.9267 27.1569 28.0254 26.564 28.0254C25.0671 28.0254 23.7916 27.508 22.7373 26.4734C21.6813 25.4387 21.1533 24.1743 21.1533 22.68C21.1533 21.1858 21.6813 19.9214 22.7373 18.8867C23.7942 17.8512 25.072 17.3334 26.5707 17.3334C28.0693 17.3334 29.3444 17.8512 30.396 18.8867C31.4476 19.9223 31.9738 21.1823 31.9747 22.6667C31.9747 23.2596 31.876 23.8387 31.6787 24.404C31.4804 24.9694 31.1924 25.4845 30.8147 25.9494L36 31.056L35.056 32ZM26.564 26.6934C27.6964 26.6934 28.6591 26.304 29.452 25.5254C30.2449 24.7476 30.6413 23.7987 30.6413 22.6787C30.6413 21.5587 30.2449 20.6103 29.452 19.8334C28.6591 19.0565 27.6964 18.6676 26.564 18.6667C25.4316 18.6658 24.4689 19.0547 23.676 19.8334C22.8831 20.612 22.4867 21.5609 22.4867 22.68C22.4867 23.7992 22.8831 24.7476 23.676 25.5254C24.4689 26.3032 25.4316 26.692 26.564 26.692"
            fill="white"
        />
    </svg>
);

const SearchIcon = React.memo(SVGComponent)
export default SearchIcon;
